import { Box, Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { IconContainer } from 'components/shared/Header/Header.styles';
import theme from 'config/theme';
import { useTranslation } from 'react-i18next';
import { StyledNoDataGridRowsBox } from './NoDataGridRows.styles';

const NoDataGridRows = ({ isLoading = false }: { isLoading?: boolean }) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan.dataGrid'
  });

  return (
    <StyledNoDataGridRowsBox>
      <Box>
        <IconContainer iconSize="LARGE" iconColor={theme.palette.primary.main}>
          <Icon type="box-open" color="inherit" />
        </IconContainer>
      </Box>
      <Typography variant="body1">
        {isLoading ? t('loading') : t('noData')}
      </Typography>
    </StyledNoDataGridRowsBox>
  );
};

export default NoDataGridRows;
